export default __webpack_public_path__ + "static/media/ic-art-single-heart.2895c8f3.svg";